import JILITABLEActions from './JILITABLEActions'

export default class TADAEGAMEActions extends JILITABLEActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'EGAME',
      gameCode: 'TADA-EGAME-004',
      platform: 'TADA',
    }

    this.gameName = 'Crash Bonus'
  }
}
